import { Link } from 'react-router-dom';
import CalcEmptyListBlock from '../../../components/CalcEmptyListBlock/CalcEmptyListBlock';

const External = () => {
  console.log('External');
  return (
    <CalcEmptyListBlock>
      You don&apos;t have results yet.
      <br />
      Follow this <Link>link</Link> if you want to find an expert to validate your assessment.
    </CalcEmptyListBlock>
  );
};

export default External;
